export default __webpack_public_path__ + "static/media/73.37e8b415.jpeg";